import { render, staticRenderFns } from "./SwitchTabSearch.vue?vue&type=template&id=a03aaaee&scoped=true&"
import script from "./SwitchTabSearch.vue?vue&type=script&lang=js&"
export * from "./SwitchTabSearch.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTabSearch.vue?vue&type=style&index=0&id=a03aaaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03aaaee",
  null
  
)

export default component.exports